module.exports = __webpack_public_path__ + "static/media/view items.3b5d4b70.svg";